import { useState } from "react";
import emailjs from '@emailjs/browser';

export default function EnquiryForm() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [focusedField, setFocusedField] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });

    // EmailJS configuration
    const serviceID = "service_dir1nrq";
    const templateID = "template_r9n4876";
    const publicKey = "83nvT9Xv6Y9ty3K5j";

    // Template parameters
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      message: formData.message,
      to_name: "BNW Developments"
    };

    // Send email using EmailJS
    emailjs.send(serviceID, templateID, templateParams, publicKey)
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setStatus({
          type: "success",
          message: "Thank you! We'll contact you shortly."
        });

        // Reset form
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: ""
        });

        setLoading(false);

        // Clear success message after 5 seconds
        setTimeout(() => {
          setStatus({ type: "", message: "" });
        }, 5000);
      })
      .catch((error) => {
        console.error('FAILED...', error);
        setStatus({
          type: "error",
          message: "Submission failed. Please try again."
        });
        setLoading(false);
      });
  };

  // Glassmorphic input styles
  const inputClasses = (fieldName) => `
    w-full bg-white/5 backdrop-blur-sm text-white px-4 py-3 rounded-lg border 
    transition-all duration-300 outline-none placeholder:text-white/40
    ${focusedField === fieldName
      ? 'border-[#c8a45e] shadow-[0_0_15px_rgba(200,164,94,0.15)] bg-white/10'
      : 'border-white/10 hover:border-white/20 hover:bg-white/10'
    }
  `;

  return (
    <div className="w-full max-w-md mx-auto p-8 rounded-2xl bg-black/20 backdrop-blur-md border border-white/10 shadow-2xl">
      <div className="text-center mb-6">
        <h3 className="text-2xl font-display font-bold text-white mb-2 tracking-wide drop-shadow-md">
          Register Interest
        </h3>
        <p className="text-gray-300 text-sm font-body drop-shadow-sm">
          Get exclusive access to brochure & floor plans
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="relative group">
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            onFocus={() => setFocusedField('name')}
            onBlur={() => setFocusedField(null)}
            className={inputClasses('name')}
            required
          />
        </div>

        <div className="relative group">
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            onFocus={() => setFocusedField('phone')}
            onBlur={() => setFocusedField(null)}
            className={inputClasses('phone')}
            required
          />
        </div>

        <div className="relative group">
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            onFocus={() => setFocusedField('email')}
            onBlur={() => setFocusedField(null)}
            className={inputClasses('email')}
            required
          />
        </div>

        <div className="relative group">
          <textarea
            name="message"
            placeholder="Your Message (Optional)"
            rows="3"
            value={formData.message}
            onChange={handleChange}
            onFocus={() => setFocusedField('message')}
            onBlur={() => setFocusedField(null)}
            className={inputClasses('message')}
          ></textarea>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-gradient-to-r from-[#c8a45e] to-[#a07d3a] text-black font-display font-bold uppercase tracking-wider py-4 rounded-lg 
            hover:shadow-[0_0_20px_rgba(200,164,94,0.4)] hover:-translate-y-0.5 active:translate-y-0
            transition-all duration-300 disabled:opacity-70 disabled:cursor-not-allowed mt-2 border border-[#c8a45e]/50"
        >
          {loading ? (
            <span className="flex items-center justify-center gap-2">
              <svg className="animate-spin h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Sending...
            </span>
          ) : "Submit Enquiry"}
        </button>

        {/* Status Messages with Animation */}
        {status.message && (
          <div
            className={`
              mt-4 p-3 rounded-lg text-sm font-medium text-center animate-fade-in backdrop-blur-sm
              ${status.type === 'success'
                ? 'bg-green-500/20 text-green-300 border border-green-500/30'
                : 'bg-red-500/20 text-red-300 border border-red-500/30'}
            `}
          >
            {status.message}
          </div>
        )}
      </form>
    </div>
  );
}
